<template>
    <header id="header" :class="headerClasses"  >
        <div class="header-container">
            <header-logo @closeMobileMenu="closeMobileMenu"   />
            <header-menu v-if="!isMobile" :wp-menu="wpMenu" />
            <header-menu-mobile v-else :wp-menu="wpMenu"
                                @toggleMenu="toggleMenu"
                                :menu-open="isMobileMenuOpen" />
            <apply-button v-bind="applyLink" />
            <mobile-menu-button v-if="isMobile"
                                :menu-open="isMobileMenuOpen"
                                @toggleMenu="toggleMenu"/>
        </div>
    </header>
</template>

<script>
    import HeaderLogo from './HeaderLogo'
    import HeaderMenu from './HeaderMenu'
    import _throttle from 'lodash/throttle'
    import ApplyButton from './ApplyButton'
    import { razzMenuApi } from '@/utils/api'
    import HeaderMenuMobile from './HeaderMenuMobile'
    import MobileMenuButton from './MobileMenuButton'

    export default {
        name: "ThemeHeader",
        components: {
            ApplyButton,
            HeaderLogo,
            HeaderMenu,
            HeaderMenuMobile,
            MobileMenuButton
        },
        data() {
            return {
                pageScrolled: false,
                isMobile: false,
                isMobileMenuOpen: false,
                applyLink: wp.settings.headerOptions.apply_now_link,
            }
        },
        created() {
            this._onScroll = _throttle(this.onScroll, 300);
            window.addEventListener('scroll', this._onScroll);
            this._onScroll();

            this._onResize = _throttle(this.onResize, 300);
            window.addEventListener('resize', this._onResize);
            this._onResize();
        },
        asyncComputed: {
            async wpMenu() {
                return razzMenuApi.get('/header-menu').then(res => res.data);
            }
        },
        computed: {
            headerClasses() {
                return `header ${this.pageScrolled ? 'scrolled':''} ${this.isMobile ? 'mobile-header':''}`
            }
        },
        methods: {
            onScroll() {
                this.pageScrolled = window.pageYOffset > 5;
            },
            onResize() {
                this.isMobile = window.innerWidth <= 1120
            },
            closeMobileMenu() {
                if (this.isMobileMenuOpen) {
                    this.isMobileMenuOpen = false;
                    document.body.classList.remove('no-scroll')
                }
            },
            toggleMenu() {
                this.isMobileMenuOpen = !this.isMobileMenuOpen
                document.body.classList.toggle('no-scroll')
            }
        },
        watch: {
            $route: {
                immediate: true,
                handler(val, oldVal) {
                    this.isMobileMenuOpen = false;
                    document.body.classList.remove('no-scroll')
                }
            }
        },
    }
</script>

<style lang="scss" scoped>
    .header {
        z-index: 999;
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        background-color: transparent;
        transition: all 300ms ease-out;
        padding: 40px;

        &.scrolled,
        &.mobile-header {
            background-color: $theme-blue;
            box-shadow: 0 3px 6px rgba(0,0,0,0.16), 0 3px 6px rgba(0,0,0,0.23);
        }

        &.scrolled:not(.mobile-header) {
            padding: 20px 40px;
        }

        &.mobile-header {
            padding: 0 0 0 40px;
        }

        @media (max-width: 400px) {
            padding: 0 0 0 5px !important;
        }
    }

    .header-container {
        width: 100%;
        display: flex;
        align-items: center;
        @include site-container;
    }
</style>